import React from 'react';
import { Card } from '../../components/ui/card';
import { Construction } from 'lucide-react';
import DeliveryLayout from '../../components/delivery/DeliveryLayout';

const PlaceholderPage = ({ title, description }) => (
  <DeliveryLayout>
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">{title}</h1>
      <Card className="bg-gray-800 border-gray-700 p-12 text-center">
        <Construction className="w-16 h-16 text-gray-600 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-white mb-2">En desarrollo</h2>
        <p className="text-gray-400">{description}</p>
      </Card>
    </div>
  </DeliveryLayout>
);

export const DeliveryAvailable = () => (
  <PlaceholderPage 
    title="Pedidos Disponibles" 
    description="Aquí verás todos los pedidos disponibles para entregar en tu zona"
  />
);

export const DeliveryHistory = () => (
  <PlaceholderPage 
    title="Historial" 
    description="Tu historial de entregas completadas aparecerá aquí"
  />
);

export const DeliveryProfile = () => (
  <PlaceholderPage 
    title="Mi Perfil" 
    description="Gestiona tu información y configuración de cuenta"
  />
);
